<template>
	<el-tabs>
		<el-tab-pane >
			<span slot="label"><i class="el-icon-document-remove"></i>{{value.ming}}组件</span>
			<div style="padding: 20px;">
				<Biaodan v-model="value.shu" :ming="Tu"></Biaodan>
			</div>
		</el-tab-pane>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-menu"></i> 组件样式</span>
			<div class="big_box" v-if="value.yangshi" style="">
				<div class="tishi" style="padding: 20px;">视频</div>
				<el-input v-model="value.yangshi.width" placeholder="px"> <template slot="prepend">宽度</template></el-input>
				<el-input v-model="value.yangshi.height" placeholder="px"> <template slot="prepend">高度</template></el-input>
				<el-input v-model="value.yangshi.text_align" placeholder="请输入内容"> <template slot="prepend">对齐</template></el-input>
				<el-input v-model="value.yangshi.margin" placeholder="px"> <template slot="prepend">外边距</template></el-input>
				<el-input v-model="value.yangshi.padding" placeholder="px"> <template slot="prepend">内边距</template></el-input>
				<el-input v-model="value.yangshi.border_radius" placeholder="px"> <template slot="prepend">圆角</template></el-input>
			</div>
			<div class="big_box" v-if="value.yangshis">
				<div class="tishi" style="padding: 20px;">图标</div>
				<el-input v-model="value.yangshis.width" placeholder="px"> <template slot="prepend">宽度</template></el-input>
				<el-input v-model="value.yangshis.height" placeholder="px"> <template slot="prepend">高度</template></el-input>
				<el-input v-model="value.yangshis.text_align" placeholder="请输入内容"> <template slot="prepend">对齐</template></el-input>
				<el-input v-model="value.yangshis.margin" placeholder="px"> <template slot="prepend">外边距</template></el-input>
				<el-input v-model="value.yangshis.padding" placeholder="px"> <template slot="prepend">内边距</template></el-input>
				<el-input v-model="value.yangshis.font_size" placeholder="px"> <template slot="prepend">大小</template></el-input>
				<el-input v-model="value.yangshis.color" placeholder="请输入颜色"> <template slot="prepend">颜色</template></el-input>
			</div>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import Biaodan from '../Biaodan.vue'
	export default {
		name: 'shipin_bianji',
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {}
				}
			}
		},
	components: {
			Biaodan
		},
	}
</script>
<link rel="stylesheet" href="Yangshi.css">
